<div class="pick-list-container">
	<div class="pick-list-header">
		<div class="descriptions-container">
			<h2 class="title">{{ field?.DisplayText }}</h2>
			<p class="description-label" *ngIf="field.description">{{field.description}}</p>
		</div>
		<button *ngIf="!field.UIOptions.tableConfig?.hideAddButton" pButton icon="far fa-plus-circle"
			(click)="showNewItemDialog()" [disabled]="control.disabled"
			class="p-button-success new-table-element-button" label="New"></button>
	</div>

	<div class="pick-list-body">
		<p-table #tableField [value]="data"
			[reorderableColumns]="(field.UIOptions.tableConfig?.isReorderable && !control.disabled) || false"
			[tableStyle]="{'min-width': '50rem'}"
			[globalFilterFields]="[field.UIOptions.tableConfig?.displayField || 'value']"
			(onRowReorder)="updateData($event)" styleClass="custom-field-table">
			<ng-template pTemplate="caption"  *ngIf="!field.UIOptions.tableConfig?.hideSearch">
				<div class="d-flex mb-2">
					<div class="col-sm-12">
						<div class="input-group input-group-sm">
							<span class="input-group-text bg-white text-secondary">
								<i class="pi pi-search"></i>
							</span>
							<input #globalFilterInput type="text"
								[placeholder]="field.UIOptions.tableConfig?.searchPlaceholder || 'Search...'"
								class="form-control border-start-0 ps-0 shadow-none"
								[class.border-end-0]="globalFilterInput.value"
								(input)="tableField.filterGlobal($any($event.target).value, 'contains')" />
							<button *ngIf="globalFilterInput.value" type="button"
								class="input-group-text bg-white border-start-0 text-secondary"
								(click)="globalFilterInput.value = ''; tableField.filterGlobal('', 'contains')"
								aria-label="Clear search">
								<i class="pi pi-times"></i>
							</button>
						</div>
					</div>
				</div>
			</ng-template>
			<ng-template
				*ngIf="field.UIOptions.tableConfig?.headerColumns && field.UIOptions.tableConfig.headerColumns.length > 0"
				pTemplate="header">
				<tr>
					<th class="numeric-index" *ngIf="field.UIOptions.tableConfig?.hasCounterInfo"></th>
					<th class="order-button" *ngIf="!control.disabled && field.UIOptions.tableConfig?.isReorderable"></th>
					<th *ngFor="let col of field.UIOptions.tableConfig.headerColumns">
						{{ col }}
					</th>
					<th class="action-button"></th>
				</tr>
			</ng-template>
			<ng-template pTemplate="body" let-rowData let-index="rowIndex">
				<tr [pReorderableRow]="(!control.disabled && field.UIOptions.tableConfig?.isReorderable) ? index : -1">
					<td class="numeric-index" *ngIf="field.UIOptions.tableConfig?.hasCounterInfo">
						{{ index + 1 }}
					</td>
					<td class="order-button" *ngIf="!control.disabled && field.UIOptions.tableConfig?.isReorderable">
						<span class="pi pi-bars" [pReorderableRowHandle]="index"></span>
					</td>
					<td>
						{{ displayValue(rowData) }}
					</td>
					<td class="action-button">
						<button pButton pRipple type="button" [disabled]="control.disabled"
							(click)="removeElement(index , rowData)" icon="pi pi-trash"
							class="p-button-rounded p-button-danger delete-row-button"></button>
					</td>
				</tr>
			</ng-template>
			<ng-template pTemplate="emptymessage">
				<tr>
					<td
						[attr.colspan]="emptyColspan">
						{{ field.UIOptions.tableConfig?.emptyMessage || 'No items added yet.' }}
					</td>
				</tr>
			</ng-template>
		</p-table>
	</div>
</div>